export default __webpack_public_path__ + "static/media/ncashUtility.e56bbfcf.png";